import React from 'react';
import './PumpScheduleEditMode.scss';
import {
    GetFullJobProfile_getJobProfile_pumpScheduleSummary as PumpScheduleSummaryData,
    GetFullJobProfile_getJobProfile_pumpScheduleSummary_proppants as ProppantData,
    GetAllProppants,
} from '../../../../types/schemaTypes';
import { useStoreContext } from '../../../App/StoreProvider';
import { useQuery } from '@apollo/client/react';
import * as PumpScheduleEditActions from '../../../../store/actions/pumpScheduleEdit';
import { Error, Loading } from '../../../_common';
import { GET_ALL_PROPPANTS } from '../../../../graphql/client/queries';
import {v4 as uuid} from 'uuid';
// import { withRouter } from 'react-router';
import {WithRouter} from  '../../../_common/WithRouter/WithRouter'
import { useAuthContext } from '../../../Auth/AuthProvider';
import { PermissionEnum } from '../../../../types/PermissionEnum';
import PumpScheduleEditHeader from './PumpScheduleEditHeader';
import WellheadRow from './WellheadRow';
import ProppantRow from './ProppantRow';
import { useParams } from 'react-router-dom';

const PumpScheduleEditMode = ({ pumpScheduleSummaryList, changeEditMode, match }: any): React.ReactElement | null => {
    const existingValues = (pumpScheduleSummaryList as PumpScheduleSummaryData[]).map(p => p.id);
    const isDeleteEnabled = useAuthContext().userHasPermission(PermissionEnum.DeletePumpSchedule);
    const [state, dispatch] = useStoreContext();
    const { pumpScheduleEdit } = state;
    const {jobId} = useParams()
    const jobIdVal:any = jobId
    //const jobId = +jobIdVal

    const { loading, error, data } = useQuery<GetAllProppants>(GET_ALL_PROPPANTS);

    if (pumpScheduleEdit.currentValues.length < 1 && pumpScheduleSummaryList.length > 0) {
        dispatch(PumpScheduleEditActions.setInitialData(pumpScheduleSummaryList, []));
    }

    if (loading) {
        return <Loading />;
    }

    if (error) {
        return <Error error={error} />;
    }

    const isProppantDeleted = (wellhead: PumpScheduleSummaryData, proppantItem: ProppantData): boolean => {
        const existingWellhead = pumpScheduleEdit.toBePosted.filter(item => item.id === wellhead.id)[0];
        if (existingWellhead) {
            const existingProppant = existingWellhead.proppants.filter(proppant => proppant.id === proppantItem.id)[0];
            return existingProppant && existingProppant.isDeleted === true;
        }
        return false;
    };

    const isWellheadDeleted = (wellhead: PumpScheduleSummaryData): boolean => {
        let isDeleted = false;
        let itemCount = 0;
        const existingWellhead = state.pumpScheduleEdit.toBePosted.filter(item => item.id === wellhead.id)[0];
        if (existingWellhead) {
            existingWellhead.proppants.forEach(item => {
                if (item.isDeleted === true) {
                    itemCount++;
                }
            });
            if (itemCount === existingWellhead.proppants.length) {
                isDeleted = true;
            }
        }

        return isDeleted;
    };

    const listProppants = (wellhead: PumpScheduleSummaryData | null): (React.ReactElement | undefined)[] | undefined => {
        if (wellhead && wellhead.proppants && wellhead.proppants.length !== 0) {
            return wellhead.proppants.map((proppantItem: ProppantData | null): React.ReactElement | undefined => {
                if (data && proppantItem !== null && !isProppantDeleted(wellhead, proppantItem)) {
                    const isNewRow = (): boolean => {
                        let isNewProppant = true;
                        (pumpScheduleSummaryList as PumpScheduleSummaryData[]).forEach(item => {
                            if (item && item.proppants) {
                                for (const proppant of item.proppants) {
                                    if (proppant && proppant.id === proppantItem.id) {
                                        isNewProppant = false;
                                        break;
                                    }
                                }
                            } else {
                                isNewProppant = false;
                            }
                        });
                        return isNewProppant;
                    };

                    return (
                        <ProppantRow
                            key={proppantItem.id}
                            wellhead={wellhead}
                            proppant={proppantItem}
                            proppants={data.getAllProppants}
                            isDeleteEnabled={isDeleteEnabled}
                            isNewRow={isNewRow()}
                            jobId={parseInt(jobIdVal)}
                        />
                    );
                }

                return undefined;
            });
        }

        return undefined;
    };

    const addWellhead = (): void => {
        if (data && data.getAllProppants) {
            const defaultProppant = data!.getAllProppants[0];
            const newProppant: ProppantData = {
                id: uuid(),
                __typename: 'PumpScheduleProppant',
                pumpScheduleId: null,
                proppantId: defaultProppant!.proppantId,
                proppantName: defaultProppant!.proppantName,
                totalVolume: null,
                volumePerBox: null,
                volumePerStage: null,
                boxesPerStage: null,
                boxesPerWell: null,
            };
            const newWellhead: PumpScheduleSummaryData = {
                __typename: 'Wellhead',
                id: uuid(),
                wellName: '',
                stages: 0,
                stageTime: null,
                totalBoxes: 0,
                proppants: [newProppant],
            };

            dispatch(PumpScheduleEditActions.addWellhead(newWellhead));
        }
    };

    return (
        <div>
            <PumpScheduleEditHeader
                pumpScheduleSummaryList={pumpScheduleSummaryList}
                jobId={parseInt(jobIdVal)}
                changeEditMode={changeEditMode}
            />
            <div>
                {pumpScheduleEdit.currentValues.map((wellhead: PumpScheduleSummaryData | null, wellheadIndex: number):
                    | React.ReactElement
                    | undefined => {
                    if (wellhead !== null && !isWellheadDeleted(wellhead)) {
                        const isNewRow = !existingValues.includes(wellhead.id);
                        return (
                            <div
                                key={wellhead.id}
                                className={
                                    wellheadIndex % 2 === 0
                                        ? 'PumpSchedule-Detail-Even-Row2 '
                                        : 'PumpSchedule-Detail-Odd-Row2 '
                                }
                            >
                                <div className="PumpScheduleEdit-Container">
                                    <WellheadRow
                                        isNewRow={isNewRow}
                                        wellhead={wellhead}
                                        isDeleteEnabled={isDeleteEnabled}
                                        jobId={parseInt(jobIdVal)}
                                    />
                                    <div className="PumpScheduleEdit-ProppantsContainer">{listProppants(wellhead)}</div>
                                </div>
                                <div className="PumpSchedule-Add2 Row">
                                    <div className="PumpSchedule-SpacerRow">
                                        <div
                                            className="PumpSchedule-AddProppant Row"
                                            onClick={() => dispatch(PumpScheduleEditActions.addProppant(wellhead))}
                                        >
                                            <i className="material-icons PumpSchedule-Edit-Icon">add_circle</i>
                                            <span className="PumpSchedule-Edit-Link">Add Proppant</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    }
                    return undefined;
                })}
                <div className="Wellhead-ButtonContainer">
                    <div className="Wellhead-Button" onClick={addWellhead}>
                        <span className="Wellhead-Button-Text">Add Well</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WithRouter(PumpScheduleEditMode);

